module.exports = __webpack_public_path__ + "img/wx-img5.df89046d.png";